import { File } from './../../models/files/files.model';

export class News {
    id?: string;
    title?: any;
    content?: any;
    custom_seo_data?: any;
    seo_title?: any;
    seo_description?: any;
    file?: File;

    constructor(options: any) {
        this.id = options.id;
        this.title = options.title;
        this.content = options.content;
        this.custom_seo_data = options.custom_seo_data;
        this.seo_title = options.seo_title;
        this.seo_description = options.seo_description;
        this.file = options.file;
    }
}
